"use client"

import React from "react"
import { Box, Skeleton, Paper } from "@mui/material"
import { motion } from "framer-motion"

const SkeletonLoader = ({ type, rows = 5 }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  }

  if (type === "table") {
    return (
      <motion.div variants={containerVariants} initial="hidden" animate="visible">
        <Paper sx={{ p: 2, borderRadius: 2 }}>
          {/* Table Header */}
          <motion.div variants={itemVariants}>
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              {[1, 2, 3, 4, 5].map((i) => (
                <Skeleton key={i} variant="text" width="20%" height={40} />
              ))}
            </Box>
          </motion.div>

          {/* Table Rows */}
          {Array.from({ length: rows }).map((_, index) => (
            <motion.div key={index} variants={itemVariants}>
              <Box sx={{ display: "flex", gap: 2, mb: 1.5 }}>
                {[1, 2, 3, 4, 5].map((i) => (
                  <Skeleton key={i} variant="text" width="20%" height={30} />
                ))}
              </Box>
            </motion.div>
          ))}
        </Paper>
      </motion.div>
    )
  }

  if (type === "card") {
    return (
      <motion.div variants={containerVariants} initial="hidden" animate="visible">
        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 3 }}>
          {Array.from({ length: rows }).map((_, index) => (
            <motion.div key={index} variants={itemVariants}>
              <Paper sx={{ p: 3, borderRadius: 2 }}>
                <Skeleton variant="text" width="60%" height={32} sx={{ mb: 2 }} />
                <Skeleton variant="rectangular" width="100%" height={120} sx={{ mb: 2, borderRadius: 1 }} />
                <Skeleton variant="text" width="80%" height={24} sx={{ mb: 1 }} />
                <Skeleton variant="text" width="40%" height={24} />
              </Paper>
            </motion.div>
          ))}
        </Box>
      </motion.div>
    )
  }

  if (type === "stats") {
    return (
      <motion.div variants={containerVariants} initial="hidden" animate="visible">
        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 3, mb: 4 }}>
          {Array.from({ length: 4 }).map((_, index) => (
            <motion.div key={index} variants={itemVariants}>
              <Paper sx={{ p: 3, textAlign: "center", borderRadius: 2 }}>
                <Skeleton variant="circular" width={60} height={60} sx={{ mx: "auto", mb: 2 }} />
                <Skeleton variant="text" width="80%" height={32} sx={{ mb: 1 }} />
                <Skeleton variant="text" width="60%" height={24} />
              </Paper>
            </motion.div>
          ))}
        </Box>
      </motion.div>
    )
  }

  if (type === "form") {
    return (
      <motion.div variants={containerVariants} initial="hidden" animate="visible">
        <Paper sx={{ p: 4, borderRadius: 2 }}>
          <motion.div variants={itemVariants}>
            <Skeleton variant="text" width="40%" height={40} sx={{ mb: 3 }} />
          </motion.div>

          {Array.from({ length: rows }).map((_, index) => (
            <motion.div key={index} variants={itemVariants}>
              <Box sx={{ mb: 3 }}>
                <Skeleton variant="text" width="30%" height={24} sx={{ mb: 1 }} />
                <Skeleton variant="rectangular" width="100%" height={56} sx={{ borderRadius: 1 }} />
              </Box>
            </motion.div>
          ))}

          <motion.div variants={itemVariants}>
            <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", mt: 4 }}>
              <Skeleton variant="rectangular" width={100} height={40} sx={{ borderRadius: 1 }} />
              <Skeleton variant="rectangular" width={120} height={40} sx={{ borderRadius: 1 }} />
            </Box>
          </motion.div>
        </Paper>
      </motion.div>
    )
  }

  return null
}

export default SkeletonLoader